import { getUserTimeZone } from '../helpers/timeHelper'
import { API_BASE, API_BASE_V2, API_BASE_V3, initHeaders, METHOD } from './constans'
import { setToken } from '../redux/actions/user.action'
import { userLogout } from '../redux/actions/auth'
import { getRefreshToken, isExpired } from './getApi'
import Cookies from 'js-cookie'
//============ START GET ====================

export const customHeaders = {
  'X-User-Time-Zone': getUserTimeZone(),
  'X-User-Agent': 'web',
}

let refreshPromise = null

export const fetchData = async (url, headersOptions = {}) => {
  let token = typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user')) || null : null

  const headers = {
    headers: {
      ...customHeaders,
      'Content-Type': 'application/json',
    },
    ...headersOptions,
  }

  if (token) {
    headers.headers['Authorization'] = `Bearer ${token.access_token}`
  }

  const response = await fetch(url, headers)

  if (response.status === 401 && token) {
    if (refreshPromise) {
      await refreshPromise
    } else {
      refreshPromise = getRefreshToken(token.refresh_token)
        .then((newTokens) => {
          refreshPromise = null
          return newTokens
        })
        .catch((err) => {
          refreshPromise = null
          throw err
        })

      const newTokens = await refreshPromise

      if (!newTokens || !newTokens.ok) {
        if (newTokens.error === 'Refresh token invalid') {
          userLogout()
          window.location.href = '/'
          return null
        }

        return null
      }

      setToken(newTokens)

      Cookies.set('token', newTokens.access_token, { path: '/' })

      token = newTokens
      headers.headers['Authorization'] = `Bearer ${token.access_token}`
    }

    const updatedToken = JSON.parse(localStorage.getItem('user'))

    const retryResponse = await fetch(url, {
      ...headers,
      headers: {
        ...headers.headers,
        Authorization: `Bearer ${updatedToken.access_token}`,
      },
    })

    return await retryResponse.json()
  }

  return await response.json()
}

export const fetchHealthData = async (url) => {
  const headers = {
    headers: {
      ...customHeaders,
      'Content-Type': 'application/json',
    },
  }

  return await fetch(url, headers)
}

let controller = new AbortController()

export const getAuthRequestBase = async (url, access_token, signal = controller.signal) => {
  const res = await fetch(`${API_BASE}${url}`, {
    signal,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
      ...customHeaders,
    },
  })

  if (res.status === 401) {
    return res
  }

  if (res.status === 403) {
    const token = JSON.parse(localStorage.getItem('user'))
    if (token?.isAdmin) {
      console.warn('❌ Admin forbidden – redirecting...')
      userLogout()
      window.location.href = '/seafarer-permission'
    }
  }

  return res
}

export const getAuthRequestBaseV2 = async (url, access_token, signal) => {
  let abortController = new AbortController()
  const abortSignal = signal ?? abortController.signal

  const res = await fetch(`${API_BASE_V2}${url}`, {
    signal: abortSignal,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
      ...customHeaders,
    },
  })

  return res
}

export const getAuthRequestBaseV3 = async (url, access_token, signal) => {
  let abortController = new AbortController()
  const abortSignal = signal ?? abortController.signal

  const res = await fetch(`${API_BASE_V3}${url}`, {
    signal: abortSignal,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
      ...customHeaders,
    },
  })

  return res
}

export async function authGetRequest(url, signal) {
  let token = JSON.parse(localStorage.getItem('user'))

  if (!token) {
    console.warn('🚨 `authGetRequest`: `localStorage` is empty! Call `logout()`!')
    window.location.href = '/'
    userLogout()
    return null
  }

  try {
    let response = await getAuthRequestBase(url, token.access_token, signal)

    if (response?.ok) {
      return response
    }

    if (response?.status === 401) {
      if (refreshPromise) {
        await refreshPromise
      } else {
        refreshPromise = getRefreshToken(token.refresh_token)
          .then((newTokens) => {
            refreshPromise = null
            return newTokens
          })
          .catch((err) => {
            refreshPromise = null
            throw err
          })

        const newTokens = await refreshPromise

        if (!newTokens || !newTokens.ok) {
          if (newTokens.error === 'Refresh token invalid') {
            userLogout()
            window.location.reload()
            return null
          }

          return null
        }

        setToken(newTokens)

        Cookies.set('token', newTokens.access_token, { path: '/' })
      }

      const updatedToken = JSON.parse(localStorage.getItem('user'))

      response = await getAuthRequestBase(url, updatedToken.access_token, signal)

      if (response?.ok) return response
    }

    return response
  } catch (error) {
    console.error('❌ Error request:', error)
    return null
  }
}

export async function authGetRequestV2(url, signal) {
  const token = getToken()
  if (!token) {
    userLogout()
    window.location.reload()
    return null
  }

  let response = await getAuthRequestBaseV2(url, token.access_token, signal)

  if (response.ok) return response

  if (response.status === 401) {
    try {
      const newTokens = await getRefreshToken(token.refresh_token)
      if (newTokens?.ok) {
        setToken(newTokens)
        Cookies.set('token', newTokens.access_token, { path: '/' })

        const updatedToken = getToken()
        return await getAuthRequestBaseV2(url, updatedToken.access_token, signal)
      } else {
        userLogout()
        window.location.reload()
        return null
      }
    } catch (error) {
      console.error('❌ Error update token:', error)
      userLogout()
      window.location.href = '/'
      return null
    }
  }

  return response
}

export async function authGetRequestV3(url, signal) {
  const token = getToken()
  if (!token) {
    userLogout()
    window.location.reload()
    return null
  }

  let response = await getAuthRequestBaseV3(url, token.access_token, signal)

  if (response.ok) return response

  if (response.status === 401) {
    try {
      const newTokens = await getRefreshToken(token.refresh_token)
      if (newTokens?.ok) {
        setToken(newTokens)
        Cookies.set('token', newTokens.access_token, { path: '/' })

        const updatedToken = getToken()
        return await getAuthRequestBaseV3(url, updatedToken.access_token, signal)
      } else {
        userLogout()
        window.location.reload()
        return null
      }
    } catch (error) {
      console.error('❌ Error update token:', error)
      userLogout()
      window.location.href = '/'
      return null
    }
  }

  return response
}

// END GET

// START POST

export const postRequest = async (url, data) => {
  const response = await fetch(`${API_BASE}${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...customHeaders,
      Accept: 'application/json',
    },
    body: JSON.stringify(data),
  })
  const json = await response.json()
  json.ok = response.ok

  return await json
}

export async function authPostRequest(url, data = {}) {
  const token = JSON.parse(localStorage.getItem('user'))
  if (token) {
    const response = await fetch(API_BASE + url, {
      method: 'POST',
      headers: {
        ...customHeaders,
        Authorization: `Bearer ${token.access_token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: data,
    })
    const result = await response.json()

    result.ok = response.ok
    return result
  }
}

export async function authPostRequestV2(url, data = {}) {
  const token = JSON.parse(localStorage.getItem('user'))
  if (token) {
    const response = await fetch(API_BASE_V2 + url, {
      method: 'POST',
      headers: {
        ...customHeaders,
        Authorization: `Bearer ${token.access_token}`,
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: data,
    })
    const result = await response.json()

    result.ok = response.ok
    return result
  }
}

export async function authPostFormData(url, data = {}) {
  const token = JSON.parse(localStorage.getItem('user'))
  if (token) {
    const response = await fetch(API_BASE + url, {
      method: 'POST',
      headers: {
        ...customHeaders,
        Authorization: `Bearer ${token.access_token}`,
      },
      body: data,
    })
    const result = await response.json()

    result.ok = response.ok
    return result
  }
}

export async function postFormData(url, data = {}) {
  const response = await fetch(API_BASE + url, {
    method: 'POST',
    body: data,
    headers: customHeaders,
  })
  const result = await response.json()

  result.ok = response.ok
  return result
}

// END POST

const getToken = () => {
  return JSON.parse(localStorage.getItem('user'))
}

export const request = async (endpoint, options) => {
  const headers = options?.headers ?? initHeaders

  const token = getToken()

  if (token && !options?.withoutToken) {
    if (isExpired(token.expires_date)) {
      const response = await getRefreshToken(token.refresh_token)

      if (response.ok) {
        setToken(response)

        return await request(endpoint, options)
      } else {
        userLogout()

        window.location.href = '/'

        return
      }
    } else {
      headers.set('Authorization', `Bearer ${token.access_token}`)
    }
  }

  const init = {
    body: options?.body,
    method: options?.method || METHOD.GET,
    headers,
  }

  const domain = options?.api ? options.api : API_BASE

  try {
    const response = await fetch(`${domain}${endpoint}`, init)

    if (response.status === 401 && !options?.withoutToken) {
      const refreshed = await getRefreshToken(token.refresh_token)

      if (refreshed?.ok) {
        setToken(refreshed)
        return await request(endpoint, options)
      } else {
        userLogout()
        window.location.href = '/'
        return
      }
    }

    const data = await response.json()

    if (!response.ok) {
      return Promise.reject(data)
    }

    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const upload = async (url, options) => {
  const formData = new FormData()

  formData.append('file', options?.file)

  if (options?.type) formData.append('type', options.type)

  return request(url, {
    body: formData,
    headers: new Headers(),
    method: options?.method || METHOD.POST,
  })
}
